module.exports = __webpack_public_path__ + "static/media/sound6.be3df992.mp3";